module.exports = __webpack_public_path__ + "img/GS_Profile-Lehlohonolo Khumalo.8a588eef.png";